import React from 'react';

// TO DO : Update with company details

const COMPANY_NAME = 'MatthewFrawley.com';
const COMPANY_NUMBER = 'N/A';

const COMPANY_REGISTERED_ADDRESS = '15 Endsleigh Road, Merstham, Surrey, RH1 3LX';
const COMPANY_ADDRESS = '15 Endsleigh Road, Merstham, Surrey, RH1 3LX';

// Data Protection Officer
const DPO_NAME = 'Matthew Frawley';
const DPO_EMAIL_ADDRESS = 'legal@matthewfrawley.com';


const privacyPolicy = {

version: 1.0,
updated: '06/10/18',
by: 'Matthew Frawley',

sections: {

1 : { 

    title: 'Introduction',

    points: [
        {
            heading: 'Overview',
            body: <p>We are committed to safeguarding the privacy of our website visitors and service users. This policy applies where we are acting as a data controller with respect to the personal data of our website visitors and service users; in other words, where we determine the purposes and means of the processing of that personal data. We use cookies on our website. 
            <br/><br/>
            We will ask you to consent to our use of cookies when you first visit our website.</p>
        }
    ]
}, 

2 : { 

    title: 'Capturing and Handling Personal Data',

    points: [

        {
            heading: 'Definition',
            body: <p style={{fontStyle: 'italic'}}>"Personal data" is defined in Article 4(1) of the GDPR:
            <br/><br/>
            "(1) 'personal data' means any information relating to an identified or identifiable natural person ('data subject'); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person".
            </p>
        },

        {
            heading: 'Overview',
            body: <p>
            In this section we have detailed:
            <br/><br/>
            (a)   the general categories of personal data that we may process;<br/>
            (b)   in the case of personal data that we did not obtain directly from you, the source and specific categories of that data;<br/>
            (c)   the purposes for which we may process personal data; and<br/>
            (d)   the legal bases of the processing.
            </p>
        },

        {
            heading: 'Usage Data',
            body: <p>
            We may process data about your use of our website and services.<br/>
            The usage data may include your IP address, geographical location, browser type and version, operating system, referral source, length of visit, page views and website navigation paths, as well as information about the timing, frequency and pattern of your service use. <br/>
            The source of the usage data is our analytics tracking system. This usage data may be processed for the purposes of analysing the use of the website. 
            The legal basis for this processing is our legitimate interests, namely monitoring and improving our website and services.
            </p>
        },


        {
            heading: 'Service Data',
            body: <p>
            We may process your personal data that are provided in the course of the use of our services.<br/>
            The service data may include information regarding your business and project. The source of the service data is you.<br/>
            The service data may be processed providing our services, ensuring the security of our website and services, maintaining back-ups of our databases and communicating with you.<br/>
            The legal basis for this processing is the performance of a contract between you and us and/or taking steps, at your request, to enter into such a contract.
            </p>
        },


        {
            heading: 'Enquiry Data',
            body: <p>
            We may process information contained in any enquiry you submit to us regarding goods and/or services. The enquiry data may be processed for the purposes of offering, marketing and selling relevant goods and/or services to you. The legal basis for this processing is consent.
            </p>
        },

        {
            heading: 'Customer Relationship Data',
            body: <p>
            We may process information relating to our customer relationships, including customer contact information. The customer relationship data may include your name, your employer, your job title or role, your contact details, and information contained in communications between us and you or your employer. The source of the customer relationship data is you or your employer. <br/>
            The customer relationship data may be processed for the purposes of managing our relationships with customers, communicating with customers, keeping records of those communications and promoting our products and services to customers. <br/>
            The legal basis for this processing is our legitimate interests, namely the proper management of our customer relationships.
            </p>
        },

        {
            heading: 'Transaction Data',
            body: <p>
            We may process information relating to transactions, including purchases of goods and services, that you enter into with us and/or through our website. The transaction data may include your contact details, your card or bank details and the transaction details. The transaction data may be processed for the purpose of supplying the purchased goods and services and keeping proper records of those transactions.<br/>
            The legal basis for this processing is the performance of a contract between you and us and/or taking steps, at your request, to enter into such a contract and our legitimate interests, namely the proper administration of our website and business.
            </p>
        },

        {
            heading: 'Notification Data',
            body: <p>
            We may process information that you provide to us for the purpose of subscribing to our email notifications and/or newsletters.
            The notification data may be processed for the purposes of sending you relevant notifications and/or newsletters.<br/>
            The legal basis for this processing is consent.
            </p>
        },

        {
            heading: 'Correspondence Data',
            body: <p>
            We may process information contained in or relating to any communication that you send to us. The correspondence data may include the communication content and metadata associated with the communication. 
            Our website will generate the metadata associated with communications made using the website contact forms. The correspondence data may be processed for the purposes of communicating with you and record-keeping.<br/>
            The legal basis for this processing is our legitimate interests, namely the proper administration of our website and business and communications with users.
            </p>
        },

        {
            heading: 'Legal Obligations',
            body: <p>
            In addition to the specific purposes for which we may process your personal data set out in this section, we may also process any of your personal data where such processing is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person.
            </p>
        },

        {
            heading: '',
            body: <p>
            Please do not supply any other person's personal data to us, unless we prompt you to do so.
            </p>
        },
    ]
}, 

3 : { 

    title: 'Sharing Personal Data',

    points: [
        {
            heading: 'Insurers and Professional Advisers',
            body: <p>
            We may disclose your personal data to our insurers and/or professional advisers insofar as reasonably necessary for the purposes of obtaining or maintaining insurance coverage, managing risks, obtaining professional advice, or the establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative or out-of-court procedure.
            </p>
        },

        {
            heading: 'Suppliers and Subcontractors',
            body: <p>
            We may disclose service data, enquiry data, correspondence data and customer relationship data to our suppliers or subcontractors identified at [URL] insofar as reasonably necessary for fulfilling your request.
            </p>
        },

        {
            heading: 'Insurers and Professional Advisers',
            body: <p>
            Financial transactions relating to our website and services are handled by our payment services providers, Wave Accounting, Stripe and Paypal. <br/>
            We will share transaction data with our payment services providers only to the extent necessary for the purposes of processing your payments, refunding such payments and dealing with complaints and queries relating to such payments and refunds. You can find information about the payment services providers' privacy policies and practices at [URLs].
            </p>
        },

        {
            heading: 'Third Party Suppliers',
            body: <p>
            We may disclose your enquiry data to one or more of those selected third party suppliers of goods and services identified on our website for the purpose of enabling them to contact you so that they can offer, market and sell to you relevant goods and/or services. Each such third party will act as a data controller in relation to the enquiry data that we supply to it; and upon contacting you, each such third party will supply to you a copy of its own privacy policy, which will govern that third party's use of your personal data.
            </p>
        },

        {
            heading: 'Legal Obligations',
            body: <p>
            In addition to the specific disclosures of personal data set out in this section, we may disclose your personal data where such disclosure is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person.
            We may also disclose your personal data where such disclosure is necessary for the establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative or out-of-court procedure.
            </p>
        },
    ]
}, 

4 : { 

    title: 'International Personal Data Transfers',

    points: [
        {
            heading: 'Overview',
            body: <p>
            In this section, we provide information about the circumstances in which your personal data may be transferred to countries outside the European Economic Area (EEA).
            </p>
        },

        {
            heading: 'Offices and Facilities',
            body: <p>
            We have offices and facilities in the United Kingdom.
            The European Commission has made an "adequacy decision" with respect to the data protection laws of this country. 
            </p>
        },

        {
            heading: 'Website Hosting',
            body: <p>
            The hosting facilities for our website are situated in London, United Kingdom. The European Commission has made an "adequacy decision" with respect to the data protection laws of this country.
            </p>
        },
    ]
}, 

5: { 

    title: 'Retaining and Deleting Personal Data',

    points: [
        {
            heading: 'Overview',
            body: <p>
            This section sets out our data retention policies and procedure, which are designed to help ensure that we comply with our legal obligations in relation to the retention and deletion of personal data.
            </p>
        },

        {
            heading: 'Retention',
            body: <p>
            Personal data that we process for any purpose or purposes shall not be kept for longer than is necessary for that purpose or those purposes.
            <br/><br/>
            All personal data will be retained for a minimum period of 30 days, and for a maximum period of 5 years.
            </p>
        },

        {
            heading: 'Legal Obligations',
            body: <p>
            Notwithstanding the other provisions of this section, we may retain your personal data where such retention is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person.
            </p>
        },
    ]
}, 

6: { 

    title: 'Policy Amendments',

    points: [
        {
            heading: '',
            body: <p>
            We may update this policy from time to time by publishing a new version on our website.
            <br/><br/>
            You should check this page occasionally to ensure you are happy with any changes to this policy.
            <br/><br/>
            We may notify you of significant changes to this policy by email or through our private messaging system.
            </p>
        },
    ]
}, 

7: { 

    title: 'Your Rights',

    points: [
        {
            heading: 'Overview',
            body: <p>
            In this section, we have summarised the rights that you have under data protection law. Some of the rights are complex, and not all of the details have been included in our summaries. Accordingly, you should read the relevant laws and guidance from the regulatory authorities for a full explanation of these rights.
            </p>
        },
        {
            heading: 'Your Principal Rights',
            body: <p>
            (a) the right to access;<br/>
            (b) the right to rectification;<br/>
            (c)	the right to erasure;<br/>
            (d) the right to restrict processing;<br/>
            (e) the right to object to processing;<br/>
            (f)	the right to data portability;<br/>
            (g) the right to complain to a supervisory authority; and<br/>
            (h) the right to withdraw consent.
            </p>
        }
    ]
}, 

8: { 

    title: 'About Cookies',

    points: [
        {
            heading: 'What is a Cookie?',
            body: <p>
            A cookie is a file containing an identifier (a string of letters and numbers) that is sent by a web server to a web browser and is stored by the browser. The identifier is then sent back to the server each time the browser requests a page from the server.
            </p>
        },
        {
            heading: 'Types of Cookie',
            body: <p>
            Cookies may be either "persistent" cookies or "session" cookies: a persistent cookie will be stored by a web browser and will remain valid until its set expiry date, unless deleted by the user before the expiry date; a session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.
            </p>
        },
        {
            heading: '',
            body: <p>
            Cookies do not typically contain any information that personally identifies a user, but personal information that we store about you may be linked to the information stored in and obtained from cookies.
            </p>
        }
    ]
}, 

9: { 

    title: 'Our use of Cookies',

    points: [
        {
            heading: 'Analysis',
            body: <p>
            We use cookies to help us to analyse the use and performance of our website and services. 
            </p>
        },
        {
            heading: 'Consent',
            body: <p>
            We use cookies to store your preferences in relation to the use of cookies.
            </p>
        }
    ]
}, 

10: { 

    title: 'Service Provider Cookies',

    points: [
        {
            heading: '',
            body: <p>
            Our service providers use cookies and those cookies may be stored on your computer when you visit our website.
            </p>
        },
        {
            heading: 'Google',
            body: <p>
            We use Google Analytics to analyse the use of our website. Google Analytics gathers information about website use by means of cookies. The information gathered relating to our website is used to create reports about the use of our website. Google's privacy policy is available at: https://www.google.com/policies/privacy/
            </p>
        }
    ]
}, 

11: { 

    title: 'Managing your Cookies',

    points: [
        {
            heading: '',
            body: <p>
            Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary from browser to browser, and from version to version. 
            </p>
        },
        {
            heading: '',
            body: <p>
            Blocking all cookies will have a negative impact upon the usability of many websites. If you block cookies, you may not be able to use all the features on our website.
            </p>
        }
    ]
}, 

12: { 

    title: 'Our Details',

    points: [
        {
            heading: '',
            body: <p>
                
            This website is owned and operated by {COMPANY_NAME}.
            <br/><br/>
            We are registered in England and Wales under registration number {COMPANY_NUMBER}, and our registered office is at {COMPANY_REGISTERED_ADDRESS}.
            <br/><br/>
            Our principal place of business is at {COMPANY_ADDRESS}.
            <br/><br/>
            You can contact us:<br/>

            (a)   	by post, to the postal address given above;<br/>
            (b)   	using our website contact form;<br/>
            (c) 	by telephone, on the contact number published on our website; or<br/>
            (d)  	by email, using the email address published on our website. 
            </p>
        }
    ]
}, 

13: { 

    title: 'Data Protection Officer (DPO)',

    points: [
        {
            heading: 'Contact Details',
            body: <p>
            {DPO_NAME}<br/>
            {DPO_EMAIL_ADDRESS}<br/>
            </p>
        }
    ]
}, 

14: { 

    title: 'Credit',

    points: [
        {
            heading: 'SEQ Legal',
            body: <p>
            This policy has been issued with the help of SEQ Legal, specialists in technology, internet and media contracts. For more information visit seqlegal.com.
            </p>
        }
    ]
}, 

}

};


export default privacyPolicy;
